/* Animația „adaugă o persoană”: fotografia persoanei apare ca un card, alunecă spre
   fotografia mare, aceasta se încețoșează o clipă, apoi apare rezultatul.
   Stările sunt puse în data-state, iar mișcarea propriu-zisă e în CSS (rf-sections.css). */
(function () {
  'use strict';

  // [stare, cât stă în ea (ms)]
  var TIMELINE = [['idle', 500], ['show', 1300], ['plus', 1500], ['move', 1300], ['blend', 1500], ['done', 0]];

  function init(el) {
    if (el.hasAttribute('data-rf-bound')) return;
    el.setAttribute('data-rf-bound', '');

    var section = el.closest('[data-rf-section]') || document;
    var late = section.querySelectorAll('[data-rf-merge-reveal]');
    var replay = el.querySelector('[data-rf-merge-replay]');
    var timer = null;

    function finish() {
      late.forEach(function (n) { n.classList.add('is-in'); });
      if (replay) replay.hidden = false;
    }

    function run() {
      clearTimeout(timer);
      if (replay) replay.hidden = true;
      late.forEach(function (n) { n.classList.remove('is-in'); });
      var i = 0;
      (function step() {
        var state = TIMELINE[i];
        el.setAttribute('data-state', state[0]);
        if (state[0] === 'done') return finish();
        i += 1;
        timer = setTimeout(step, state[1]);
      })();
    }

    if (RF.reducedMotion || !('IntersectionObserver' in window)) {
      el.setAttribute('data-state', 'done');
      late.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }

    el.setAttribute('data-state', 'idle');
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      run();
    }, { threshold: 0.4 });
    io.observe(el);

    if (replay) replay.addEventListener('click', run);
  }

  RF.register(function (root) { root.querySelectorAll('[data-rf-merge]').forEach(init); });
})();
